module.exports = __webpack_public_path__ + "img/mpg.ba83857d.png";